import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=7db45b6a&"
var script = {}
import style0 from "./Container.vue?vue&type=style&index=0&id=7db45b6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports